import { OIDCHttpClient } from "lib/oidc_http_client";

export const identifyProduct = async (productId: number, payload: any) => {
  const url = `${process.env.REACT_APP_API_URL}/murfy-erp/products/${productId}/identification/`;
  const client = new OIDCHttpClient();
  return await client.post(url, payload);
};
